/* tslint:disable */
/* eslint-disable */
import { Injectable } from '@angular/core';
import { HttpClient, HttpResponse, HttpContext } from '@angular/common/http';
import { BaseService } from '../base-service';
import { ApiConfiguration } from '../api-configuration';
import { StrictHttpResponse } from '../strict-http-response';
import { RequestBuilder } from '../request-builder';
import { Observable } from 'rxjs';
import { map, filter } from 'rxjs/operators';

import { AddOtpRequestGenerated } from '../models/add-otp-request-generated';
import { OtpRequestGenerated } from '../models/otp-request-generated';

@Injectable({
  providedIn: 'root',
})
export class OtpRequestServiceGenerated extends BaseService {
  constructor(
    config: ApiConfiguration,
    http: HttpClient
  ) {
    super(config, http);
  }

  /**
   * Path part for operation addOtpRequest
   */
  static readonly AddOtpRequestPath = '/otp-request';

  /**
   * Add OTP request.
   *
   * Add OTP request
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `addOtpRequest()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  addOtpRequest$Response(params?: {
    context?: HttpContext
    body?: AddOtpRequestGenerated
  }
): Observable<StrictHttpResponse<OtpRequestGenerated>> {

    const rb = new RequestBuilder(this.rootUrl, OtpRequestServiceGenerated.AddOtpRequestPath, 'post');
    if (params) {
      rb.body(params.body, 'application/json');
    }

    return this.http.request(rb.build({
      responseType: 'json',
      accept: 'application/json',
      context: params?.context
    })).pipe(
      filter((r: any) => r instanceof HttpResponse),
      map((r: HttpResponse<any>) => {
        return r as StrictHttpResponse<OtpRequestGenerated>;
      })
    );
  }

  /**
   * Add OTP request.
   *
   * Add OTP request
   *
   * This method provides access to only to the response body.
   * To access the full response (for headers, for example), `addOtpRequest$Response()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  addOtpRequest(params?: {
    context?: HttpContext
    body?: AddOtpRequestGenerated
  }
): Observable<OtpRequestGenerated> {

    return this.addOtpRequest$Response(params).pipe(
      map((r: StrictHttpResponse<OtpRequestGenerated>) => r.body as OtpRequestGenerated)
    );
  }

  /**
   * Path part for operation getOtpRequest
   */
  static readonly GetOtpRequestPath = '/otp-request/{otpRequestId}';

  /**
   * Get OTP request.
   *
   * Get OTP request
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `getOtpRequest()` instead.
   *
   * This method doesn't expect any request body.
   */
  getOtpRequest$Response(params: {
    otpRequestId: string;
    context?: HttpContext
  }
): Observable<StrictHttpResponse<OtpRequestGenerated>> {

    const rb = new RequestBuilder(this.rootUrl, OtpRequestServiceGenerated.GetOtpRequestPath, 'get');
    if (params) {
      rb.path('otpRequestId', params.otpRequestId, {});
    }

    return this.http.request(rb.build({
      responseType: 'json',
      accept: 'application/json',
      context: params?.context
    })).pipe(
      filter((r: any) => r instanceof HttpResponse),
      map((r: HttpResponse<any>) => {
        return r as StrictHttpResponse<OtpRequestGenerated>;
      })
    );
  }

  /**
   * Get OTP request.
   *
   * Get OTP request
   *
   * This method provides access to only to the response body.
   * To access the full response (for headers, for example), `getOtpRequest$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  getOtpRequest(params: {
    otpRequestId: string;
    context?: HttpContext
  }
): Observable<OtpRequestGenerated> {

    return this.getOtpRequest$Response(params).pipe(
      map((r: StrictHttpResponse<OtpRequestGenerated>) => r.body as OtpRequestGenerated)
    );
  }

  /**
   * Path part for operation deleteOtpRequest
   */
  static readonly DeleteOtpRequestPath = '/otp-request/{otpRequestId}';

  /**
   * Delete OTP Request.
   *
   * Delete OTP Request
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `deleteOtpRequest()` instead.
   *
   * This method doesn't expect any request body.
   */
  deleteOtpRequest$Response(params: {
    otpRequestId: string;
    context?: HttpContext
  }
): Observable<StrictHttpResponse<void>> {

    const rb = new RequestBuilder(this.rootUrl, OtpRequestServiceGenerated.DeleteOtpRequestPath, 'delete');
    if (params) {
      rb.path('otpRequestId', params.otpRequestId, {});
    }

    return this.http.request(rb.build({
      responseType: 'text',
      accept: '*/*',
      context: params?.context
    })).pipe(
      filter((r: any) => r instanceof HttpResponse),
      map((r: HttpResponse<any>) => {
        return (r as HttpResponse<any>).clone({ body: undefined }) as StrictHttpResponse<void>;
      })
    );
  }

  /**
   * Delete OTP Request.
   *
   * Delete OTP Request
   *
   * This method provides access to only to the response body.
   * To access the full response (for headers, for example), `deleteOtpRequest$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  deleteOtpRequest(params: {
    otpRequestId: string;
    context?: HttpContext
  }
): Observable<void> {

    return this.deleteOtpRequest$Response(params).pipe(
      map((r: StrictHttpResponse<void>) => r.body as void)
    );
  }

}
